import { useState } from "react";
import axiosInstance from "@/hooks/axios";
import { isAxiosError } from "axios";
import { JobPost } from "@/types/jobPost";
import { SavedJobPost } from "@/types/user";

export interface ToggleSaveJobPostData {
  job_post_id: JobPost["id"];
}

export interface ToggleSaveJobPostResponse {
  success: boolean;
  message: string;
  saved_job: SavedJobPost;
}

export const useToggleSaveJobPost = () => {
  const [data, setData] = useState<ToggleSaveJobPostResponse | null>(null);
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);

  const toggleSaveJobPost = async (formData: ToggleSaveJobPostData) => {
    setLoading(true);
    setError(null);

    const authToken = localStorage.getItem("authToken");
    if (!authToken) {
      setError("Not authenticated.");
      setLoading(false);
      return;
    }

    try {
      const response = await axiosInstance.post<ToggleSaveJobPostResponse>(
        "users/users/toggle_save_job_post/",
        formData,
        {
          headers: {
            Authorization: `Bearer ${authToken}`,
          },
        },
      );
      setData(response.data);
      return response.data;
    } catch (err: unknown) {
      if (isAxiosError(err)) {
        setError(err.message);
      } else if (err instanceof Error) {
        setError(err.message);
      } else {
        setError("An unknown error occurred.");
      }
    } finally {
      setLoading(false);
    }
  };

  return { data, loading, error, toggleSaveJobPost };
};
